import React from 'react';
import ListItem from "@mui/material/ListItem/ListItem";
import ListItemText from "@mui/material/ListItemText/ListItemText";
import IconButton from "@mui/material/IconButton/IconButton";
import Collapse from "@mui/material/Collapse/Collapse";
import List from "@mui/material/List/List";
import Divider from "@mui/material/Divider/Divider";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Nullable } from '../../models/common/Nullable';
import {NavLink} from "react-router-dom";
import {NavDrawerItemIcon} from "./NavDrawerItemIcon";
import {ListItemButton, ListItemIcon, Tooltip} from "@mui/material";
import {VisibilityHandler} from "../common/VisibilityHandler";

/**
 * typescript
 */
interface NavDrawerItemCollapseableProps {
    title: string
    name: string
    isExpanded: boolean
    childItems: Nullable<JSX.Element[] | JSX.Element>
    viewLink?: string
    active?: boolean
    hideText?: boolean
    onClick: ( identifier: string ) => void
    toggleExpansion( name: string ): void
}

function NavDrawerItemCollapseable(
    {
        viewLink, title, name, isExpanded, childItems, toggleExpansion, active, hideText, onClick
    }: NavDrawerItemCollapseableProps
) {

    let activeStyle = active
        ? "menu-border-active"
        : "menu-border"

    const colorScheme = active ? 'icon-active' : 'icon';

    if( hideText ) {
        activeStyle += " menu-border-hidden";
    }


    return (
        <>

        <div className={activeStyle}>
            <div>
                    {
                        ( typeof viewLink !== "undefined" )
                        ? (
                            <div>

                                <Tooltip title={ title }  placement={'right-end'}>
                                    <div  className={"flex nav-drawer-background "+ activeStyle} style={{ alignItems: "center" }}>
                                        <div style={{ width: hideText ? '50%' : '239px' }}>
                                            <NavLink to={ viewLink } onClick={() => onClick( name ) }>
                                                <ListItemButton style={{ display: "flex", height: '60px', width: '100%' }} >
                                                    <ListItemIcon>
                                                        <NavDrawerItemIcon
                                                            itemIdentifier={ name}
                                                            itemLink={ viewLink }
                                                            className={ colorScheme }
                                                        />
                                                    </ListItemIcon>
                                                    <VisibilityHandler isVisible={ ! hideText ?? true }>
                                                        <ListItemText
                                                            primary={ title }
                                                            onClick={ () => toggleExpansion( name )}
                                                            className={ colorScheme }
                                                        />
                                                    </VisibilityHandler>
                                                </ListItemButton>
                                            </NavLink>
                                        </div>
                                       <div  style={{ width: hideText ? '50%' : '10%' }}>
                                           <VisibilityHandler isVisible={false}>
                                               <IconButton onClick={ e => {
                                                   toggleExpansion( name );

                                               }}>
                                                   {isExpanded ? <ExpandLess/> : <ExpandMore/>}
                                               </IconButton>
                                           </VisibilityHandler>

                                       </div>

                                        </div>
                                </Tooltip>

                            </div>
                        )
                        : (
                            <div>
                                <Tooltip title={ title }  placement={'right-end'}>
                                <ListItemButton style={{ height: '60px' }} className={"nav-drawer-background "}>
                                    <div style={{ width: hideText ? '50%' : '56px' }}>
                                        <ListItemIcon  onClick={ () => toggleExpansion( name )  }>
                                            <NavDrawerItemIcon itemIdentifier={ name } itemLink={""} className={colorScheme} />
                                        </ListItemIcon>
                                    </div>
                                    <div style={{ width: hideText ? '0' : '60%', textAlign: 'left', justifyContent: 'left' }}>
                                        <VisibilityHandler isVisible={ ! hideText ?? true }>
                                            <ListItemText
                                                    primary={ title }
                                                    className={ colorScheme }
                                                    onClick={ () => toggleExpansion( name )  }
                                            />
                                        </VisibilityHandler>
                                    </div>
                                    <div  style={{ width: hideText ? '50%' : '10%', alignItems: 'flex-end' }}>
                                        <IconButton onClick={() => toggleExpansion( name )}>
                                            {isExpanded ? <ExpandLess className={colorScheme} /> : <ExpandMore className={colorScheme} />}
                                        </IconButton>
                                    </div>

                                </ListItemButton>

                                </Tooltip>
                            </div>


                       )
                    }

            </div>
        </div>
            <Collapse in={isExpanded} timeout="auto">
                <List component={"div" as "ul"} disablePadding>
                    { childItems }
                </List>
            </Collapse>
            <Divider/>
        </>
    );
}

export default NavDrawerItemCollapseable;